import { createIcon } from '../icon'
import UnderwearWomenIcon from '../svg/UnderwearWomenIcon'

export const UnderwearWomenIconDefault = createIcon(UnderwearWomenIcon)
